import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface ImageUpdateContextType {
  // 画像が更新されたことを通知する
  notifyImageUpdate: () => void;
  // 画像更新通知をリッスンする
  onImageUpdate: (callback: () => void) => () => void;
}

const ImageUpdateContext = createContext<ImageUpdateContextType | null>(null);

interface ImageUpdateProviderProps {
  children: ReactNode;
}

export const ImageUpdateProvider: React.FC<ImageUpdateProviderProps> = ({ children }) => {
  const [updateCallbacks, setUpdateCallbacks] = useState<Set<() => void>>(new Set());

  // 画像更新を通知する関数
  const notifyImageUpdate = useCallback(() => {
    console.log('ImageUpdateContext: notifyImageUpdate called, callbacks count:', updateCallbacks.size);
    updateCallbacks.forEach(callback => {
      try {
        console.log('ImageUpdateContext: Calling callback');
        callback();
      } catch (error) {
        console.error('Error in image update callback:', error);
      }
    });
  }, [updateCallbacks]);

  // 画像更新通知をリッスンする関数
  const onImageUpdate = useCallback((callback: () => void) => {
    setUpdateCallbacks(prev => {
      const newCallbacks = new Set(prev);
      newCallbacks.add(callback);
      return newCallbacks;
    });

    // クリーンアップ関数を返す
    return () => {
      setUpdateCallbacks(prev => {
        const newCallbacks = new Set(prev);
        newCallbacks.delete(callback);
        return newCallbacks;
      });
    };
  }, []);

  const contextValue: ImageUpdateContextType = {
    notifyImageUpdate,
    onImageUpdate,
  };

  return (
    <ImageUpdateContext.Provider value={contextValue}>
      {children}
    </ImageUpdateContext.Provider>
  );
};

// カスタムフック
export const useImageUpdate = () => {
  const context = useContext(ImageUpdateContext);
  if (!context) {
    throw new Error('useImageUpdate must be used within an ImageUpdateProvider');
  }
  return context;
};